<template>
  <div class="comments-container">
    <div class="comments-item" v-for="(item, index) in commentList" :key="index">
      <div class="item-header">
        <span class="hm-name">{{ item.created_account }}</span>
        <div class="rating-time-container">
          <span class="rating-date">{{ item.created_date }}</span>
          <span class="rating-time">{{ item.created_time }}</span>
        </div>
      </div>
      <div class="item-body">
        <el-input
          type="textarea"
          :autosize="textSize"
          readonly
          resize="none"
          v-model="item.comment"
          class="title">
        </el-input>
      </div>
    </div>
    <p class="rating-tips">{{ $t('hm.label.rating.commentTips') }}</p>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    commentList: {
      require: true
    }
  },
  data () {
    return {
      textSize: {
        minRows: 3,
        maxRows: 5
      }
    }
  },
  computed: {
  },
  created () {
  },
  beforeDestroy () {

  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.comments-container {
  margin: 20px 0;
  background-color: #FFFFFF;
  padding: 20px 10px;

  .comments-item {
    margin-bottom: 20px;

    &> div {
      display: flex;
      font-size: 14px;
    }

    .item-header {
      justify-content: space-between;
      margin-bottom: 10px;

      .rating-time-container {
        color: #646566;
        display: flex;
        align-items: center;

        .rating-date {
          font-size: 12px;
        }

        .rating-time {
          font-size: 10px;
          margin-left: 10px;
          color: #0096cc;
        }
      }
    }
  }

  .rating-tips {
    color: #646566;
    font-size: 12px;
  }
}
</style>
